// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const WindowsIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="#0078D4"
      d="M1 1h10.43v10.42H1zm11.57 0H23v10.42H12.57zM1 12.57h10.43V23H1zm11.57 0H23V23H12.57"
    />
  </svg>,
  "Windows",
);
export default WindowsIcon;
